<template>
    <div>
        <div class='footer-column-title'>
            ABOUT US
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('about')"><a class="footer-link">About Us</a></div>
            <div @click="onClickLink('contact-us')"><a class="footer-link">Contact Us</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>